<div class="kt-card p-10">

<h3 class="text-lg mb-5">Two Factor Authentication</h3>

<input class="kt-input"
       type="text"
       placeholder="Enter OTP"
       [(ngModel)]="model.otpCode"
       name="otp">

<button class="kt-btn kt-btn-primary mt-4"
        (click)="verify()">
Verify OTP
</button>

</div>